<template>
    <div>
        <DataTable :value="seasons" lazy paginator dataKey="id"
                   v-model:rows="searchCriteria.page.limit" v-model:first="searchCriteria.page.offset"
                   removableSort :totalRecords="totalRecords" :loading="loading" @page="onPage"
                   @sort="onPage" :rowsPerPageOptions="[5,10,20,50]" selection-mode="single" v-model:selection="selectedTableElement" @row-click="onRowSelect"
                   filterDisplay="row" scrollable
                   scrollHeight="calc(100vh - 300px)">
            <Column field="year" :header="$t('message.season.year')" :sortable="true"
                    filterField="year" :showFilterMenu="false"
                    :showClearButton="false" class="w-2">
                <template #body="{ data }">
                    {{ data.year }}
                </template>
<!--                <template #filter>-->
<!--                    <CustomCalendar name="year" v-model="searchCriteria.year"-->
<!--                                    :showTime="false" :placeholder="$t('message.season.year')" dateFormat="yy" view="year" showButtonBar-->
<!--                                    @update:modelValue="search" max-date="null"/>-->
<!--                </template>-->
            </Column>
            <Column field="startDate" :header="$t('message.season.startDate')" :sortable="true"
                    filterField="startDate" :showFilterMenu="false"
                    :showClearButton="false" class="w-2">
                <template #body="{ data }">
                    {{ data.startDate }}
                </template>
<!--                <template #filter>-->
<!--                    <CustomCalendar name="startDate" v-model="searchCriteria.startDate" selectionMode="single"-->
<!--                                    :showTime="false" :placeholder="$t('message.season.minDate')" showButtonBar-->
<!--                                    @update:modelValue="search" max-date="null"/>-->
<!--                </template>-->
            </Column>
            <Column field="endDate" :header="$t('message.season.endDate')" :sortable="true"
                    filterField="endDate" :showFilterMenu="false"
                    :showClearButton="false" class="w-2">
                <template #body="{ data }">
                    {{ data.endDate }}
                </template>
<!--                <template #filter>-->
<!--                    <CustomCalendar name="endDate" v-model="searchCriteria.endDate" selectionMode="single"-->
<!--                                    :showTime="false" :placeholder="$t('message.season.maxDate')" showButtonBar-->
<!--                                    @update:modelValue="search" max-date="null"/>-->
<!--                </template>-->
            </Column>
            <template #empty>
                {{ $t('message.other.emptyTable') }}
            </template>
        </DataTable>
    </div>
</template>

<script>
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { searchSeason, searchSeasonCount } from "@/swagger/vue-api-client";
import CustomInputText from "@/components/form/CustomInputText.vue";
import CustomSelectOneYesNo from "@/components/form/CustomSelectOneYesNo.vue";
import { ScrollToUtils } from "@/utils/ScrollToUtils";
import CustomCalendar from "@/components/form/CustomCalendar.vue";

export default {
    name: "SeasonsTable",
    components: {
        CustomCalendar,
        CustomInputText,
        Button,
        Column,
        DataTable,
        CustomSelectOneYesNo,
    },

    props: {
        modelValue: null,
    },

    emits: ["update:modelValue", "showForm"],

    data() {
        return {
            loading: false,
            totalRecords: 0,
            seasons: [],
            searchCriteria: this.getClearSearchCriteria(),
            selectedTableElement: null,
        };
    },

    mounted() {
        this.updateTotalRecords();
        this.onPage(this.getFirstPage());
    },

    methods: {
        search() {
            this.onPage(this.getFirstPage());
            this.updateTotalRecords();
        },

        onPage(season) {
            this.loading = true;
            this.searchCriteria.page.offset = season.first;
            this.searchCriteria.page.limit = season.rows;
            this.searchCriteria.page.sortField = season.sortField;
            this.searchCriteria.page.sortOrder = season.sortOrder;

            searchSeason({ body: this.searchCriteria }).then((response) => {
                this.seasons = response.data;
                this.loading = false;
            });
        },

        updateTotalRecords() {
            searchSeasonCount({ body: this.searchCriteria }).then((response) => {
                this.totalRecords = response.data;
            });
        },

        getFirstPage() {
            return {
                first: this.searchCriteria.page.offset,
                rows: this.searchCriteria.page.limit,
            };
        },

        onRowSelect(season) {
            ScrollToUtils.scrollToElement();
            this.$emit("showForm");
            this.selectedSeason = season.data;
        },

        getClearSearchCriteria() {
            return {
                startDate: null,
                endDate: null,
                active: null,
                year: null,
                page: {
                    limit: 10,
                    offset: 0,
                    sortField: null,
                    sortOrder: null,
                },
            };
        },

        addNewSeason() {
            this.selectedTableElement = null;
        },

        reloadTable() {
            this.search();
        },
    },

    computed: {
        selectedSeason: {
            get() { return this.modelValue; },
            set(value) { this.$emit("update:modelValue", value); },
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
